var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09409 6.13235C4.75227 6.51176 4.79724 6.97941 5.15706 7.22647C5.50787 7.47353 5.93065 7.39412 6.2275 7.06765C7.63077 5.49706 9.6997 4.5 12.0025 4.5C15.9155 4.5 19.1088 7.35 19.5766 11.0647H18.2363C17.5976 11.0647 17.4357 11.4882 17.7775 11.9735L19.7925 14.7882C20.0803 15.1941 20.5121 15.2029 20.8089 14.7882L22.8149 11.9824C23.1747 11.4882 23.0038 11.0647 22.3561 11.0647H21.1238C20.629 6.57353 16.6891 3 12.0025 3C9.25893 3 6.78521 4.21765 5.09409 6.13235ZM1.18112 12.0265C0.830302 12.5118 0.992218 12.9441 1.63988 12.9441H2.88124C3.36699 17.4353 7.31593 21 12.0025 21C14.7461 21 17.2288 19.7735 18.9199 17.8676C19.2527 17.4882 19.2078 17.0118 18.8569 16.7647C18.5061 16.5176 18.0743 16.6059 17.7865 16.9324C16.3922 18.5118 14.3233 19.5 12.0025 19.5C8.08054 19.5 4.8872 16.65 4.42843 12.9441H5.76874C6.40741 12.9441 6.56932 12.5118 6.2275 12.0353L4.21255 9.22059C3.9247 8.81471 3.49292 8.80588 3.19607 9.22059L1.18112 12.0265Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/Sync.c140ba938365101873858a6f6e68bf54.svg";
export { ForwardRef as ReactComponent };